<template>
  <div style="width: 100%; height: 100%; display: flex; align-items: center; justify-content: space-between; background: #409eff; padding: 0 10px; box-sizing: border-box;">
    <!-- 左侧区域 -->
    <div style="display: flex; align-items: center; height: 100%; gap: 8px; flex: 1; min-width: 0; overflow: hidden;">
      <el-button v-if="isMobile" size="small" style="background: transparent; border: none; color: #fff; font-size: 22px; padding: 4px; line-height: 1; font-weight: bold;" @click="$emit('toggleDrawer')">☰</el-button>
      <el-button v-if="isMobile" size="small" style="background: transparent; border: none; color: #fff; font-size: 20px; padding: 4px; line-height: 1; font-weight: bold;" @click="handleRefresh">⟳</el-button>
      <template v-if="!isMobile">
        <div style="display: flex; align-items: center; gap: 8px; flex-shrink: 0; cursor: pointer; height: 100%;" @click="$router.push('/')">
          <img src="/static/logo.png" style="width: 28px; height: 28px;" alt="logo" />
          <span style="color: #fff; font-size: 16px; font-weight: 600; white-space: nowrap;">{{ $store.state.common.systemInfo.name || '中州气联' }}</span>
        </div>
        <el-divider direction="vertical" style="height: 24px; border-color: rgba(255,255,255,0.3);" />
        <div style="display: flex; align-items: center; height: 100%; gap: 2px; overflow-x: auto; flex-wrap: nowrap;">
          <div v-for="(item, k) in list" :key="k" @click="setCurrent(k)" style="display: flex; align-items: center; justify-content: center; height: 100%; padding: 0 14px; cursor: pointer; border-radius: 6px 6px 0 0; font-size: 13px; font-weight: 500; transition: all 0.2s; background: transparent; white-space: nowrap; flex-shrink: 0;" :style="{ color: k === current ? '#000000' : 'rgba(255,255,255,0.85)', background: k === current ? 'rgba(255,255,255,0.2)' : 'transparent' }" @mouseenter="hoverIndex = k" @mouseleave="hoverIndex = null" :class="{ 'menu-item-hover': hoverIndex === k && k !== current }">
            <el-icon size="16" style="margin-right: 4px;"><component :is="$store.state.icons.icons[item.icon]" /></el-icon>
            <span>{{ item.name }}</span>
          </div>
        </div>
        <el-divider direction="vertical" style="height: 24px; border-color: rgba(255,255,255,0.3);" />
        <div style="display: flex; align-items: center; font-size: 12px; color: rgba(255,255,255,0.85); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; gap: 4px; min-width: 0;">
          <span style="color: rgba(255,255,255,0.6); flex-shrink: 0;">当前路径：</span>
          <el-breadcrumb separator="/" style="font-size: 12px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
            <el-breadcrumb-item v-for="(item, index) in breadcrumbs" :key="index" style="display: inline-block;">{{ item }}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </template>
    </div>

    <!-- 右侧用户下拉菜单 -->
    <div style="display: flex; align-items: center; gap: 2px; flex-shrink: 0; margin-left: 4px;">
      <el-dropdown trigger="click" @command="handleCommand" size="small" placement="bottom-end" :append-to-body="false">
        <div style="display: flex; align-items: center; gap: 2px; cursor: pointer; padding: 4px 6px 4px 4px; border-radius: 20px; transition: all 0.25s ease; background: rgba(255,255,255,0.08);" @mouseenter="$event.currentTarget.style.background='rgba(255,255,255,0.2)'" @mouseleave="$event.currentTarget.style.background='rgba(255,255,255,0.08)'">
          <el-avatar :size="isMobile ? 22 : 26" :src="userAvatar" style="background: rgba(255,255,255,0.2); border: 1.5px solid rgba(255,255,255,0.3);" />
		  <span style="color: #fff; font-size: 13px; margin: 0 4px;">{{ user?.name || '管理员' }}</span>
          <el-icon style="color: rgba(255,255,255,0.5); font-size: 12px; margin-left: 0;"><ArrowDown /></el-icon>
        </div>
        <template #dropdown>
          <el-dropdown-menu style="padding: 4px 0; min-width: 120px; border-radius: 10px; box-shadow: 0 6px 24px rgba(0,0,0,0.15);">
            <el-dropdown-item command="profile" style="font-size: 13px; padding: 8px 16px; border-radius: 6px; margin: 2px 4px;">
              <el-icon style="margin-right: 8px; font-size: 14px;"><User /></el-icon>
              <span>修改密码</span>
            </el-dropdown-item>
            <div style="height: 1px; margin: 4px 12px; background: #f0f2f5;"></div>
            <el-dropdown-item command="logout" style="font-size: 13px; padding: 8px 16px; border-radius: 6px; margin: 2px 4px; color: #f56c6c;">
              <el-icon style="margin-right: 8px; font-size: 14px;"><SwitchButton /></el-icon>
              <span>退出登录</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </div>

    <!-- 修改密码弹窗 -->
    <el-dialog
      title="修改密码"
      v-model="passwordDialogVisible"
      :width="dialogWidth"
      align-center
      custom-class="password-dialog"
      @close="closePasswordDialog"
      destroy-on-close
    >
      <el-form :rules="passwordRules" :model="passwordForm" label-width="auto" label-position="top" ref="passwordFormRef" size="default">
        <el-form-item label="当前密码" prop="oldPassword">
          <el-input v-model="passwordForm.oldPassword" type="password" placeholder="请输入当前密码" show-password />
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword">
          <el-input v-model="passwordForm.newPassword" type="password" placeholder="请输入新密码" show-password />
        </el-form-item>
        <el-form-item label="确认新密码" prop="confirmPassword">
          <el-input v-model="passwordForm.confirmPassword" type="password" placeholder="请再次输入新密码" show-password />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="closePasswordDialog" size="default">取消</el-button>
        <el-button type="primary" @click="submitPassword" :loading="passwordLoading" size="default">确定</el-button>
      </template>
    </el-dialog>

    <!-- 退出登录确认弹窗 -->
    <el-dialog
      title="系统提示"
      v-model="logoutDialogVisible"
      :width="dialogWidth"
      align-center
      custom-class="logout-confirm-dialog"
      destroy-on-close
    >
      <div style="padding: 8px 0; font-size: 15px; color: #303133; text-align: center;">
        确定要退出登录吗？
      </div>
      <template #footer>
        <el-button @click="logoutDialogVisible = false" size="default">取消</el-button>
        <el-button type="primary" @click="confirmLogout" size="default">确定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { pub } from '../../../common/event.js';
import { ElMessage } from 'element-plus';

export default {
  name: 'FengMenuTop',
  data() {
    return {
      hoverIndex: null,
      isMobile: window.innerWidth < 768,
      passwordDialogVisible: false,
      passwordLoading: false,
      passwordForm: { oldPassword: '', newPassword: '', confirmPassword: '' },
      passwordRules: {
        oldPassword: [{ required: true, message: '请输入当前密码', trigger: 'blur' }],
        newPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 6, message: '密码长度不能少于6位', trigger: 'blur' },
        ],
        confirmPassword: [
          { required: true, message: '请再次输入新密码', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (value !== this.passwordForm.newPassword) callback(new Error('两次输入密码不一致'));
              else callback();
            },
            trigger: 'blur',
          },
        ],
      },
      logoutDialogVisible: false,
    };
  },
  computed: {
    list() { return this.$store.getters['menu/filteredList'] || []; },
    ...mapState({ current: (state) => state.menu.current }),
    user() { return this.$store.state.user.user; },
    userAvatar() {
      const fileurl = this.$store.state.common.systemInfo?.fileurl || '';
      const avatar = this.user?.avatar || '';
      return avatar ? fileurl + avatar : 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png';
    },
    breadcrumbs() {
      const path = this.$route.path;
      const query = this.$route.query || {};
      const menus = this.list;
      function findBreadcrumbs(menuList, targetPath, targetQuery, pathStack = []) {
        for (const item of menuList) {
          const currentStack = [...pathStack, item.name];
          let isMatch = false;
          if (item.path) {
            isMatch = targetPath === item.path || targetPath.startsWith(item.path + '/');
            if (isMatch && item.query) {
              const itemQuery = item.query || {};
              const targetQ = targetQuery || {};
              isMatch = Object.keys(itemQuery).every((key) => itemQuery[key] == targetQ[key]);
            }
          }
          if (isMatch) return currentStack;
          if (item.menus && item.menus.length > 0) {
            const found = findBreadcrumbs(item.menus, targetPath, targetQuery, currentStack);
            if (found) return found;
          }
        }
        return null;
      }
      let breadcrumbNames = null;
      for (const group of menus) {
        const found = findBreadcrumbs([group], path, query);
        if (found) { breadcrumbNames = found; break; }
      }
      if (breadcrumbNames && breadcrumbNames.length > 0) return breadcrumbNames;
      const metaTitle = this.$route.meta?.title;
      if (metaTitle) return [metaTitle];
      const segments = path.split('/').filter(Boolean);
      if (segments.length > 0) {
        let last = segments[segments.length - 1];
        if (last === 'index' && segments.length > 1) last = segments[segments.length - 2];
        return [last.charAt(0).toUpperCase() + last.slice(1) || '首页'];
      }
      return ['首页'];
    },
    pageTitle() {
      const crumbs = this.breadcrumbs;
      return crumbs[crumbs.length - 1] || '首页';
    },
    dialogWidth() { return this.isMobile ? '90%' : '500px'; },
  },
  watch: {
    '$route': { handler() { this.updateCurrentByRoute(); }, immediate: true },
    list: { handler() { this.updateCurrentByRoute(); }, deep: true },
  },
  mounted() {
    this.updateCurrentByRoute();
    window.addEventListener('resize', this.handleResize);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize() { this.isMobile = window.innerWidth < 768; },
    updateCurrentByRoute() {
      const path = this.$route.path;
      const menus = this.list;
      for (let i = 0; i < menus.length; i++) {
        const group = menus[i];
        let matched = false;
        if (group.menus && group.menus.length > 0) {
          matched = group.menus.some((item) => {
            if (!item.path) return false;
            return path === item.path || path.startsWith(item.path + '/');
          });
        } else if (group.path) {
          matched = path === group.path || path.startsWith(group.path + '/');
        }
        if (matched && this.current !== i) {
          this.$store.commit('menu/setCurrent', i);
          return;
        }
      }
    },
    setCurrent(index) {
      this.$store.commit('menu/setCurrent', index);
      const group = this.list[index];
      if (!group) return;
      let target = null;
      if (group.menus && group.menus.length > 0) {
        const firstChild = group.menus.find((item) => item.path) || group.menus[0];
        target = { path: firstChild.path, query: firstChild.query || {} };
      } else if (group.path) {
        target = { path: group.path, query: {} };
      }
      if (target && (this.$route.path !== target.path || JSON.stringify(this.$route.query) !== JSON.stringify(target.query))) {
        this.$router.push(target);
      }
    },
    handleCommand(command) {
      if (command === 'logout') this.logoutDialogVisible = true;
      else if (command === 'profile') {
        this.passwordDialogVisible = true;
        this.passwordForm = { oldPassword: '', newPassword: '', confirmPassword: '' };
        this.$nextTick(() => { this.$refs.passwordFormRef?.clearValidate(); });
      }
    },
    async confirmLogout() {
      this.logoutDialogVisible = false;
      await this.$store.dispatch('user/logout');
      this.$store.commit('config/setLeftBar', false);
      this.$router.push('/login/login');
    },
    closePasswordDialog() {
      this.passwordDialogVisible = false;
      this.passwordForm = { oldPassword: '', newPassword: '', confirmPassword: '' };
      this.$refs.passwordFormRef?.clearValidate();
    },
    async submitPassword() {
      try { await this.$refs.passwordFormRef.validate(); } catch (e) { return; }

      this.passwordLoading = true;
      try {
        const ret = await this.$r.post('account/account/password', {
          oldPassword: this.passwordForm.oldPassword,
          newPassword: this.passwordForm.newPassword,
        });
        if (!ret || !ret.success) throw new Error(ret?.message || '修改失败');

        ElMessage.success('密码修改成功，请重新登录');
        this.closePasswordDialog();
        await this.$store.dispatch('user/logout');
        pub('gologinpage', {});
      } catch (e) {
        ElMessage.error(e.message || '请求失败，请重试');
      } finally {
        this.passwordLoading = false;
      }
    },
    handleRefresh() { this.$router.go(0); },
  },
};
</script>

<style scoped>
.menu-item-hover { background: rgba(255, 255, 255, 0.15) !important; }
.el-breadcrumb ::v-deep .el-breadcrumb__item { display: inline-flex; align-items: center; }
.el-breadcrumb ::v-deep .el-breadcrumb__inner { color: rgba(255, 255, 255, 0.85) !important; cursor: default; }
.el-breadcrumb ::v-deep .el-breadcrumb__separator { color: rgba(255, 255, 255, 0.5) !important; }
.el-dropdown-menu { border-radius: 10px !important; padding: 4px 0 !important; box-shadow: 0 6px 24px rgba(0,0,0,0.15) !important; border: 1px solid rgba(0,0,0,0.04) !important; }
.el-dropdown-menu .el-dropdown-item { font-size: 13px !important; padding: 8px 16px !important; border-radius: 6px !important; margin: 2px 4px !important; transition: all 0.2s !important; }
.el-dropdown-menu .el-dropdown-item:hover { background: #f0f4f9 !important; }
.el-dropdown-menu .el-dropdown-item.is-active { background: #ecf5ff !important; }

@media screen and (max-width: 768px) {
  /* 修改密码弹窗：高度自适应，不拉伸 */
  .password-dialog .el-dialog {
    width: 90% !important;
    max-width: 500px !important;
    max-height: 80vh !important;
    height: auto !important;
    border-radius: 12px !important;
    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.25) !important;
  }
  .password-dialog .el-dialog__body {
    flex: 0 0 auto !important;
    max-height: 60vh !important;
    overflow-y: auto !important;
    padding: 16px 16px 8px !important;
  }
  .password-dialog .el-dialog__footer {
    flex-shrink: 0 !important;
    padding: 8px 16px 16px !important;
  }
  .password-dialog .el-dialog__header {
    padding: 14px 16px 4px !important;
  }

  .logout-confirm-dialog .el-dialog {
    height: 130px !important;
    max-height: 130px !important;
    width: 90% !important;
    max-width: 500px !important;
    border-radius: 12px !important;
    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.25) !important;
    margin: 0 auto !important;
    display: flex !important;
    flex-direction: column !important;
    justify-content: center !important;
  }
  .logout-confirm-dialog .el-dialog__body {
    flex: 0 0 auto !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    padding: 6px 16px 4px !important;
    min-height: auto !important;
    font-size: 14px;
    overflow: visible !important;
  }
  .logout-confirm-dialog .el-dialog__footer {
    flex: 0 0 auto !important;
    padding: 4px 16px 12px !important;
  }
  .logout-confirm-dialog .el-dialog__footer .el-button {
    font-size: 13px !important;
    padding: 6px 18px !important;
  }
}
</style>